<script setup lang="ts">
import type {Message} from '@/client/mentor/MessagesClient'
import {assistantChatMessageContextKey} from '@/components/assistant/chat/messageContext'
import MessageDebug from '@/components/assistant/chat/message/MessageDebug.vue'
import {computed, inject} from 'vue'

const props = defineProps<{
  message: Message
}>()

defineOptions({
  inheritAttrs: false,
})

const messageContext = inject(assistantChatMessageContextKey)

const isMobileVersion = computed(() => messageContext?.isMobileVersion.value ?? false)
const printSenderLabel = computed(() => messageContext?.getPrintSenderLabel(props.message) ?? '')
const printTimestamp = computed(() => messageContext?.getPrintTimestamp(props.message) ?? '')
</script>

<template>
  <div class="assistant-message-layout print:w-full print:border-t-new-sm print:pt-3">
    <div
      v-if="printSenderLabel || printTimestamp"
      class="pb-2 hidden print:flex items-center justify-between gap-4 text-xs text-black"
    >
      <span>{{ printSenderLabel }}</span>
      <span>{{ printTimestamp }}</span>
    </div>

    <div
      v-bind="$attrs"
      class="rounded-lg px-3 py-2 break-words print:max-w-none print:rounded-none print:px-0 print:py-0"
      :class="isMobileVersion ? 'w-full max-w-full' : 'w-fit max-w-[80%]'"
    >
      <slot />
      <MessageDebug :message="message" />
    </div>
  </div>
</template>
